module.exports = __webpack_public_path__ + "img/rotate.5e4f55f2.svg";